import { useEffect, useState } from 'react';
import Marquee from 'react-fast-marquee';
import axios from 'axios';
import { API } from '../lib/api';

const SponsorMarquee = () => {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        const response = await axios.get(`${API}/sponsors`);
        if (response.data.length > 0) {
          setSponsors(response.data);
        } else {
          // Use placeholder sponsors if none in DB
          setSponsors([
            { id: '1', name: 'Meichan Moves', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/Black-Dog-Logo.png', website_url: 'https://blackdogaudio.com/' },
            { id: '2', name: 'Poly Props', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/Poly-Props-Logo.png', website_url: 'https://www.poly-propsus.com/' },
            { id: '3', name: 'Path to Happy', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/Path-to-Happy-2024.png', website_url: 'https://thepathtohappy.com/' },
            { id: '4', name: 'Old Eastern Ink', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/Ink-Logo-1024x683-1.png', website_url: 'https://www.oldeasterninkshop.com/' },
            { id: '5', name: 'GHB Logo', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/GHB-Logo.png', website_url: '#' },
          ]);
        }
      } catch (error) {
        console.error('Error fetching sponsors:', error);
        // Use placeholder sponsors if API fails
        setSponsors([
          { id: '1', name: 'Black Dog Audio', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/Black-Dog-Logo.png', website_url: 'https://blackdogaudio.com/' },
          { id: '2', name: 'Poly Props', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/Poly-Props-Logo.png', website_url: 'https://www.poly-propsus.com/' },
          { id: '3', name: 'Path to Happy', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/Path-to-Happy-2024.png', website_url: 'https://thepathtohappy.com/' },
          { id: '4', name: 'Old Eastern Ink', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/Ink-Logo-1024x683-1.png', website_url: 'https://www.oldeasterninkshop.com/' },
          { id: '5', name: 'GHB Logo', logo_url: 'https://whatshappeningbaltimore.com/wp-content/uploads/2025/06/GHB-Logo.png', website_url: '#' },
        ]);
      } finally {
        setLoading(false);
      }
    };
    fetchSponsors();
  }, []);

  if (loading) {
    return (
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="h-24 flex items-center justify-center">
            <div className="animate-pulse text-gray-500">Loading sponsors...</div>
          </div>
        </div>
      </section>
    );
  }

  // Double the sponsors for seamless looping
  const displaySponsors = [...sponsors, ...sponsors];

  return (
    <section data-testid="sponsor-section" className="py-12 bg-white">
      <div className="max-w-6xl mx-auto px-6 mb-8">
        <h2 className="font-outfit text-2xl sm:text-3xl font-bold text-black text-center">
          Whats Happening Baltimore is Made Possible by Our Sponsors
        </h2>
      </div>

      <Marquee
        gradient={false}
        speed={40}
        pauseOnHover={true}
        direction="left"
      >
        {displaySponsors.map((sponsor, index) => (
          <a
            key={`${sponsor.id}-${index}`}
            href={sponsor.website_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`sponsor-${sponsor.id}`}
            className="mx-8 flex items-center justify-center h-24 min-w-[120px]"
          >
            <img
              src={sponsor.logo_url}
              alt={sponsor.name}
              className="max-h-20 max-w-[140px] object-contain grayscale hover:grayscale-0 transition-all duration-300"
              loading="lazy"
            />
          </a>
        ))}
      </Marquee>
    </section>
  );
};

export default SponsorMarquee;
